import { useSelector } from 'react-redux'
import { languages } from '../../../../../../configs/language'
import { Element } from '../../../../../common/html/element'
import { Panel } from '../../../../../common/panel'
import { Table } from '../../../../../common/table'
import { expiryDate } from '../../../../../dashboard/components/currentPlan/helper'
import { formatText } from '../../../../../helpers/value'
import { CLASS_HIDE_TABLE_PDF } from '../../../../../utils/common'
import { COMPLETED_STATUS, PAYMENT_METHOD_PACKAGE } from '../../constants'
import { DateOrderedCell } from '../../table/DateOrderedCell'
import { OrderStatusCell } from '../../table/OrderStatusCell'
import {
  selectConciergeServiceCellData,
  selectConciergeServiceData,
  selectConciergeServiceIds,
  selectIsLoading,
} from '../store/slice'
import { DownloadCell } from './table/DownloadCell'
import { FileType } from './table/FileType'
import { LanguageCell } from './table/LanguageCell'
import { PriceCell } from './table/PriceCell'
import { TypeAndVersion } from './table/TypeAndVersion'

const schema = {
  NO: {
    colId: 'id',
    title: '#',
  },
  COMPANY_NAME: {
    colId: 'referenceName',
    title: 'COMPANY_NAME',
  },
  TYPE: {
    colId: 'fiinGateReportTypeName',
    title: 'TYPE_VERSION',
  },
  LANGUAGE: {
    colId: 'languageCode',
    title: 'LANGUAGE',
  },
  FILE_TYPE: {
    colId: 'fileType',
    title: 'FILE_TYPE',
  },
  DELIVERY_DATE: {
    colId: 'expectedDeliveryDate',
    title: 'DELIVERY_DATE',
  },
  STATUS: {
    colId: 'status',
    title: 'ORDER_STATUS',
  },
  PRICE: {
    colId: 'priceVND',
    title: 'PRICE',
  },
  REPORT: {
    colId: 'orderDetailId',
    title: 'REPORT',
  },
}

export const BusinessConcierge = ({ isPdf = false }) => {
  const ids = useSelector(selectConciergeServiceIds)
  const isLoading = useSelector(selectIsLoading)
  const data = useSelector(selectConciergeServiceData)

  const renderContent = () => {
    return (
      !!ids.length && (
        <div className="mt2">
          <Element
            className={`${CLASS_HIDE_TABLE_PDF}`}
            style={{
              color: '#0553A5',
              fontSize: 14,
              fontWeight: 600,
              padding: '0px 12px',
              paddingTop: isPdf ? 12 : 0,
            }}
          >
            Business Concierge Service
          </Element>
          <Table
            ids={ids}
            isNoDataWithHead
            isLoading={isLoading}
            getDataFromRedux={selectConciergeServiceCellData}
            isDisplayScroll={false}
            isNoStickyHead={isPdf}
            schema={Object.keys(schema)
              .filter((key) => !isPdf || key !== 'REPORT')
              .map((key) => {
                const result = {
                  colId: schema[key].colId,
                  title:
                    'userManagement.orderManagement.orderDetail.' +
                    schema[key].title,
                  isI18n: true,
                  isHtml: true,
                  thStyle: { textAlign: 'left' },
                  render: (val, { locale, rowId }) => {
                    switch (schema[key].colId) {
                      case schema.COMPANY_NAME.colId:
                        return val
                      case schema.TYPE.colId:
                        return (
                          <TypeAndVersion
                            val={val}
                            rowId={rowId}
                            getDataFromRedux={selectConciergeServiceCellData}
                          />
                        )
                      case schema.LANGUAGE.colId:
                        return <LanguageCell val={val || languages.en} />
                      case schema.DELIVERY_DATE.colId:
                        return <DateOrderedCell val={val} locale={locale} />
                      case schema.REPORT.colId:
                        const isNotCompletedStatus =
                          data[rowId - 1]?.status !== COMPLETED_STATUS
                        const isExpired =
                          expiryDate(data[rowId - 1]?.expiryDate) <= 0
                        return (
                          <DownloadCell
                            val={val}
                            isDisabled={isNotCompletedStatus}
                            isExpired={isExpired}
                          />
                        )
                      case schema.STATUS.colId:
                        return <OrderStatusCell val={val} />
                      case schema.PRICE.colId:
                        return (
                          <>
                            {data[rowId - 1]?.paymentMethod ===
                            PAYMENT_METHOD_PACKAGE ? (
                              <></>
                            ) : (
                              <PriceCell
                                val={val}
                                rowId={rowId}
                                getDataFromRedux={
                                  selectConciergeServiceCellData
                                }
                              />
                            )}
                          </>
                        )
                      case schema.FILE_TYPE.colId:
                        return <FileType fileType={val} />
                      default:
                        return formatText(val)
                    }
                  },
                }

                return result
              })}
          />
        </div>
      )
    )
  }

  if (isPdf) {
    return (
      <Panel
        label="userManagement.orderManagement.orderDetail.ORDER_DETAILS"
        isI18n
      >
        {renderContent()}
      </Panel>
    )
  }

  return <>{renderContent()}</>
}
